import axios, { AxiosRequestConfig } from 'axios'
import { url } from 'src/provider/config/constant'


export const authApiCaller = axios.create({
    baseURL:  url.AUTH_BASE_URL 
})

authApiCaller.interceptors.request.use(
    async (config: AxiosRequestConfig<any>) => {
        const token = await localStorage.getItem('authToken')
        
        if(token) {
            config.headers!.Authorization = `Bearer ${token}`
        }
        return config;
    },

    (err) => {
        return Promise.reject(err)
    }
)

//export default instance